(function () {
  'use strict';

  function setText(node, value) {
    if (node && value) node.textContent = value;
  }

  function setCard(card, kicker, heading) {
    if (!card) return;
    setText(card.querySelector('.ln-feed-card__kicker'), kicker);
    setText(card.querySelector('h3'), heading);
  }

  function relabelPriceButton(button, label) {
    if (!button || !label) return;
    var current = button.textContent.trim();
    var separator = current.indexOf('·');
    button.textContent = separator > -1
      ? label + ' · ' + current.slice(separator + 1).trim()
      : label;
  }

  function addComparisonLink(card, href, label, sourceHandle, targetHandle) {
    if (!card || card.querySelector('[data-ln-copy-comparison]')) return;
    var link = document.createElement('a');
    link.className = 'ln-compare-card__detail';
    link.href = href;
    link.textContent = label;
    link.dataset.lnCopyComparison = 'true';
    link.dataset.lnProductLink = '';
    link.dataset.sourceProduct = sourceHandle;
    link.dataset.targetProduct = targetHandle;
    link.dataset.lnPlacement = 'length_comparison';
    card.querySelector('.ln-feed-card__body').appendChild(link);
  }

  function refine() {
    var shell = document.querySelector('[data-ln-swipe-placement="product_information"]');
    if (!shell || shell.dataset.lnCopyRefined === 'true') return;
    shell.dataset.lnCopyRefined = 'true';

    var handle = shell.dataset.lnProduct || '';
    var section = shell.closest('.ln-product-feed');
    if (!section) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-ln-swipe-card]'));
    cards.forEach(function (card, index) {
      setText(card.querySelector('.ln-feed-card__number'), String(index + 1).padStart(2, '0'));
    });

    var configs = {
      'magnetic-knife-holder-acacia-15-7': {
        eyebrow: 'Før du vælger 40 cm',
        heading: 'Er Stillelinjen den rigtige længde til din væg?',
        intro: 'Korte svar om plads, knive, akacietræ og montering. Så kan du vælge 40 cm med åbne øjne.',
        cards: [
          ['40 cm i praksis', 'Til de knive, du griber efter hver dag'],
          ['Mål før du monterer', 'Læg knivene op, før listen kommer på væggen'],
          ['40 eller 50 cm', 'Vælg 40 cm, når væggen sætter grænsen'],
          ['Akacie og mål', 'Lyst træ. Ca. 40 cm. Enkel pleje.'],
          ['Før montering', 'Den er kompakt med vilje']
        ],
        fitLabels: ['Vælg 40 cm hvis', 'Gå op i 50 cm hvis'],
        primaryCta: 'Vælg 40 cm',
        midLabel: 'Passer 40 cm til din væg?',
        comparison: {
          href: 'products/magnetic-knife-holder-acacia-19-6',
          label: 'Har du plads? Se 50 cm i akacie',
          target: 'magnetic-knife-holder-acacia-19-6'
        }
      },
      'magnetic-knife-holder-acacia-19-6': {
        eyebrow: 'Før du vælger 50 cm',
        heading: 'Har du vægplads til lidt mere luft mellem knivene?',
        intro: 'Se hvordan 50 cm adskiller sig fra den kompakte model, før du vælger længde og placering.',
        cards: [
          ['50 cm i praksis', 'Til flere eller bredere hverdagsknive'],
          ['Mål før du monterer', 'Mål 50 cm og husk plads til at løfte knivene'],
          ['40 eller 50 cm', 'Vælg 50 cm, når væggen ikke er begrænsningen'],
          ['Akacie og mål', 'Lyst træ og mere længde på væggen'],
          ['Før montering', 'Tjek væggen og klingerne først']
        ],
        fitLabels: ['Vælg 50 cm hvis', 'Vælg 40 cm hvis'],
        primaryCta: 'Vælg 50 cm',
        midLabel: 'Er 50 cm den rigtige længde?',
        comparison: {
          href: 'products/magnetic-knife-holder-acacia-15-7',
          label: 'Mindre væg? Se 40 cm i akacie',
          target: 'magnetic-knife-holder-acacia-15-7'
        }
      },
      'magnetic-knife-holder-walnut-19-6': {
        eyebrow: 'Før du vælger valnød',
        heading: 'Vil du have knivene frem i et mørkere træudtryk?',
        intro: 'Se længde, plads og begrænsninger, før du vælger den mørke 50 cm skinne.',
        cards: [
          ['Valnød på væggen', 'En mørkere ramme om de knive, du bruger mest'],
          ['Mål før du monterer', 'Mål væggen og knivene samlet'],
          ['Vælg træ og længde', 'Vælg valnød for udtrykket, ikke kun funktionen'],
          ['Valnød og mål', '50 cm og den pleje træet kræver'],
          ['Før montering', 'Tjek væggen og klingerne først']
        ],
        primaryCta: 'Vælg valnød',
        midLabel: 'Passer den mørke 50 cm skinne?'
      }
    };

    var config = configs[handle];
    if (!config) return;

    var header = section.querySelector('.ln-product-feed__header');
    setText(header && header.querySelector('.eyebrow'), config.eyebrow);
    setText(header && header.querySelector('h2'), config.heading);
    setText(header && header.querySelector('p'), config.intro);

    config.cards.forEach(function (copy, index) {
      setCard(cards[index], copy[0], copy[1]);
    });

    if (config.fitLabels && cards[2]) {
      var labels = cards[2].querySelectorAll('dt');
      setText(labels[0], config.fitLabels[0]);
      setText(labels[1], config.fitLabels[1]);
    }

    relabelPriceButton(section.querySelector('[data-ln-placement="feed_first_card"]'), config.primaryCta);
    setText(section.querySelector('[data-ln-placement="feed_last_card"]'), config.primaryCta);
    setText(section.querySelector('.ln-midbuy__label'), config.midLabel);
    setText(section.querySelector('[data-ln-placement="feed_footer"]'), 'Gå til køb');

    if (config.comparison && cards[2]) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      addComparisonLink(
        cards[2],
        root + config.comparison.href,
        config.comparison.label,
        handle,
        config.comparison.target
      );
    }

    document.dispatchEvent(new CustomEvent('ln:event', {
      detail: {
        event: 'product_copy_refined',
        product: handle,
        placement: 'product_information'
      }
    }));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refine);
  else refine();
}());
